import { Stripe } from '@stripe/stripe-js';

/**
 * @description Type guard to check if a value is a Stripe instance.
 * @param {any} value - Value to check.
 * @returns {value is Stripe} True if value is a Stripe instance.
 */
export function isStripe(value: any): value is Stripe {
  return value && typeof value === 'object' && 'createToken' in value;
}

/**
 * @description Type guard to check if a value is the string 'tokenex'.
 * @param {any} value - Value to check.
 * @returns {value is string} True if value is the string 'tokenex'.
 */
export function isTokenex(value: any): value is string {
  return value && typeof value === 'string' && value === 'tokenex';
}
